import React from 'react';
import { Box, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from '@mui/material';

const mockData = [
  { agent: 'John Doe', leadName: 'Amit Sharma', phone: '+91-9876543210', direction: 'Outgoing', duration: '03:24', outcome: 'Connected', callTime: '2025-12-18 10:15' },
  { agent: 'Jane Smith', leadName: 'Priya Verma', phone: '+91-9876501234', direction: 'Incoming', duration: '05:12', outcome: 'Follow-up Scheduled', callTime: '2025-12-18 11:02' },
  { agent: 'Rahul Kumar', leadName: 'Rohit Singh', phone: '+91-9988776655', direction: 'Outgoing', duration: '00:45', outcome: 'Not Connected', callTime: '2025-12-18 09:47' },
];

const AgentCallDetailedReportPage = () => {
  return (
    <Box sx={{ flexGrow: 1, pt: 0, pb: 3, px: { xs: 2, sm: 3 } }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold', color: 'text.primary', mb: 0.5 }}
        >
          Agent Call Report (Detailed)
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Call-level log of all agent interactions with leads.
        </Typography>
      </Box>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Agent</TableCell>
              <TableCell>Lead Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Direction</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Outcome</TableCell>
              <TableCell>Call Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockData.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.agent}</TableCell>
                <TableCell>{row.leadName}</TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>{row.direction}</TableCell>
                <TableCell>{row.duration}</TableCell>
                <TableCell>{row.outcome}</TableCell>
                <TableCell>{row.callTime}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AgentCallDetailedReportPage;


